/* MapleWeld - Custom Cut (cut-to-length) for the product buy box.
   Works with sections/mwh-product + assets/mwh-pdp.js; configured by
   sections/mwh-cut-length.

   HOW IT SELLS
   The product's metafield custom.cut_product points at a hidden (Unlisted)
   per-foot product whose variants are the cable sizes. Their prices ARE the
   price per foot, edited in Shopify admin like any other price. Choosing
   "Custom Cut" here adds that per-foot variant with quantity = feet, so
   cart, checkout, taxes, discounts and the order all calculate natively:
   line total = price per foot x feet. No app, no Shopify Plus.

   HOW IT HOOKS IN
   mwh-pdp.js is not modified. This file listens on document in the capture
   phase, so in Custom Cut mode it handles the option clicks and the form
   submit before mwh-pdp.js sees them, and stays out of the way otherwise. */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents, fmt) {
    fmt = fmt || '${{amount}}';
    cents = Number(cents) || 0;
    function d(n, prec, thou, dec) {
      var p = (n / 100).toFixed(prec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return p[1] ? p[0] + dec + p[1] : p[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return d(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return d(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return d(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return d(cents, 2, "'", '.');
        default: return d(cents, 2, ',', '.');
      }
    });
  }

  var SCISSORS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M20 4 8.1 15.9M14.5 14.5 20 20M8.1 8.1 12 12"/></svg>';

  function setup(host) {
    var root = document.querySelector('[data-mwp]');
    if (!root) return;
    var cfg, cuts, mains;
    try { cfg = JSON.parse($('[data-mwc-cfg]', host).textContent); } catch (e) { return; }
    try { cuts = JSON.parse($('[data-mwc-variants]', host).textContent); } catch (e) { cuts = []; }
    try { mains = JSON.parse($('[data-mwp-variants]', root).textContent); } catch (e) { mains = []; }

    var lenFs = $('[data-mwp-opt="' + cfg.len + '"]', root);
    var sizeFs = $('[data-mwp-opt="' + cfg.size + '"]', root);
    var form = document.getElementById(root.getAttribute('data-form'));
    var tpl = $('template[data-mwc-tpl]', host);
    if (!lenFs || !sizeFs || !form || !tpl || !cuts.length) return;
    if (root.getAttribute('data-mwc-ready') === '1') return;
    root.setAttribute('data-mwc-ready', '1');

    var fmt = root.getAttribute('data-money') || '${{amount}}';
    var select = $('[data-mwp-select]', root);
    var qtyWrap = $('.mwp__qty', root);
    var atc = $('[data-mwp-atc]', root);
    var atcText = $('[data-mwp-atctext]', root);
    var msg = $('[data-mwp-msg]', root);
    var sticky = $('[data-mwp-sticky]', root);
    var on = false;

    /* ---- the Custom Cut button, added to the Length option ---- */
    var firstRadio = $('input[type="radio"]', lenFs);
    var vals = $('.mwp__vals', lenFs);
    if (!firstRadio || !vals) return;
    var lab = document.createElement('label');
    lab.className = 'mwp__val mwc-val';
    var radio = document.createElement('input');
    radio.type = 'radio';
    radio.name = firstRadio.name;
    if (firstRadio.getAttribute('form')) radio.setAttribute('form', firstRadio.getAttribute('form'));
    radio.value = cfg.label;
    radio.setAttribute('data-mwc-radio', '');
    var face = document.createElement('span');
    face.innerHTML = SCISSORS;
    face.appendChild(document.createTextNode(cfg.label));
    lab.appendChild(radio);
    lab.appendChild(face);
    vals.appendChild(lab);

    /* ---- the length panel, placed right under the Length option ---- */
    var panel = tpl.content.firstElementChild.cloneNode(true);
    lenFs.parentNode.insertBefore(panel, lenFs.nextSibling);
    var ftIn = $('[data-mwc-ft]', panel);
    var rateEl = $('[data-mwc-rate]', panel);
    var calcRate = $('[data-mwc-calcrate]', panel);
    var ftLbl = $('[data-mwc-ftlabel]', panel);
    var totalEl = $('[data-mwc-total]', panel);
    var tipEl = $('[data-mwc-tip]', panel);
    var errEl = $('[data-mwc-err]', panel);
    var chipsWrap = $('[data-mwc-chips]', panel);

    ftIn.min = cfg.min;
    ftIn.max = cfg.max;
    ftIn.value = cfg.def;

    String(cfg.presets || '').split(/[\s,;]+/).forEach(function (p) {
      var n = parseInt(p, 10);
      if (!(n >= cfg.min && n <= cfg.max)) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mwc__chip';
      b.value = String(n);
      b.textContent = n + ' ft';
      b.addEventListener('click', function () { ftIn.value = n; update(); });
      chipsWrap.appendChild(b);
    });
    var chips = $$('.mwc__chip', chipsWrap);
    if (!chips.length) chipsWrap.hidden = true;

    function sizeVal() { var r = $('input:checked', sizeFs); return r ? r.value : ''; }
    function cutFor(size) {
      for (var i = 0; i < cuts.length; i++) if (cuts[i].size === size) return cuts[i];
      return null;
    }
    function feet() { var n = parseInt(ftIn.value, 10); return isFinite(n) ? n : NaN; }

    function setUrl(ft) {
      if (!window.history || !history.replaceState || !window.URL) return;
      try {
        var u = new URL(window.location.href);
        if (on) { u.searchParams.set('cut', String(ft > 0 ? ft : cfg.def)); u.searchParams.delete('variant'); }
        else u.searchParams.delete('cut');
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      } catch (e) {}
    }

    /* the cheapest box/reel of this size that is at least this long and costs no more */
    function boxTip(size, ft, total) {
      if (!cfg.tip || !total) { tipEl.hidden = true; return; }
      var best = null;
      mains.forEach(function (v) {
        if (!v.available || v.options[cfg.size] !== size) return;
        var m = /(\d+(?:\.\d+)?)\s*(?:ft|feet|')/i.exec(v.options[cfg.len] || '');
        if (!m) return;
        var L = parseFloat(m[1]);
        if (L >= ft && v.price <= total && (!best || v.price < best.v.price)) best = { v: v, L: L };
      });
      if (!best) { tipEl.hidden = true; return; }
      var save = total - best.v.price;
      var extra = best.L - ft;
      var t = $('[data-mwc-tiptext]', tipEl);
      t.textContent = 'Better value: the ' + best.v.options[cfg.len] + ' is ' + money(best.v.price, fmt) +
        (save > 0 ? ' – ' + money(save, fmt) + ' less' : ' – the same price') +
        (extra > 0 ? ', with ' + extra + ' ft more cable.' : '.');
      var b = $('[data-mwc-switch]', tipEl);
      b.setAttribute('data-value', best.v.options[cfg.len]);
      tipEl.hidden = false;
    }

    function update() {
      var size = sizeVal();
      var c = cutFor(size);
      $$('.mwp__val', sizeFs).forEach(function (l) {
        var i = $('input', l);
        l.classList.toggle('mwc-nocut', on && !!i && !cutFor(i.value));
      });
      if (!on) return;

      var ft = feet();
      var okFt = ft >= cfg.min && ft <= cfg.max;
      var ok = !!(c && c.available && okFt);
      var total = c && okFt ? c.price * ft : 0;
      var rate = c ? money(c.price, fmt) + ' / ft' : '–';

      rateEl.textContent = rate;
      calcRate.textContent = rate;
      ftLbl.textContent = (okFt ? ft : '–') + ' ft';
      totalEl.textContent = total ? money(total, fmt) : '–';
      chips.forEach(function (b) { b.classList.toggle('is-on', parseInt(b.value, 10) === ft); });

      var lb = $('[data-mwp-optval]', lenFs);
      if (lb) lb.textContent = cfg.label + (okFt ? ' · ' + ft + ' ft' : '');
      var sb = $('[data-mwp-optval]', sizeFs);
      if (sb) sb.textContent = size;

      /* price box shows the total for the length entered */
      var price = $('[data-mwp-price]', root);
      if (price) { price.textContent = total ? money(total, fmt) : rate; price.classList.remove('is-offer'); }
      ['[data-mwp-compare]', '[data-mwp-save]', '[data-mwp-badge]'].forEach(function (s) {
        var el = $(s, root); if (el) el.hidden = true;
      });
      ['[data-mw-offer-note]', '.mwp__terms', '[data-mwp-dyn]'].forEach(function (s) {
        var el = $(s, root); if (el) el.style.display = 'none';
      });
      var sku = $('[data-mwp-sku]', root), skuw = $('[data-mwp-skuwrap]', root);
      if (sku) sku.textContent = c && c.sku ? c.sku : '';
      if (skuw) skuw.hidden = !(c && c.sku);

      var err = '';
      if (!c || !c.available) err = cfg.na.replace('[size]', size);
      else if (!(ft >= cfg.min)) err = cfg.under.replace('[min]', cfg.min);
      else if (ft > cfg.max) err = cfg.over.replace('[max]', cfg.max);
      errEl.textContent = err;
      errEl.hidden = !err;

      var label = ok ? cfg.atc.replace('[ft]', ft) : (c && c.available ? 'Enter a length' : 'Unavailable');
      if (atc) atc.disabled = !ok;
      if (atcText) atcText.textContent = label;
      if (sticky) {
        var sp = $('[data-mwp-stickyprice]', sticky), sv = $('[data-mwp-stickyvar]', sticky);
        var sa = $('[data-mwp-stickyatc]', sticky), st = $('[data-mwp-stickytext]', sticky);
        if (sp) sp.textContent = total ? money(total, fmt) : rate;
        if (sv) sv.textContent = size + ' · ' + cfg.label + (okFt ? ' ' + ft + ' ft' : '') + ' · ';
        if (sa) sa.disabled = !ok;
        if (st) st.textContent = label;
      }
      boxTip(size, ft, total);
      setUrl(ft);
    }

    function enter() {
      on = true;
      root.classList.add('mwc-on');
      radio.checked = true;
      panel.hidden = false;
      if (qtyWrap) qtyWrap.style.display = 'none';
      if (msg) { msg.textContent = ''; msg.classList.remove('is-err'); }
      update();
    }

    function exit() {
      if (!on) return;
      on = false;
      root.classList.remove('mwc-on');
      panel.hidden = true;
      if (qtyWrap) qtyWrap.style.display = '';
      /* mwh-pdp.js re-renders price, offer note, SKU and buttons for the
         box/reel that was picked; just give back what was hidden here */
      ['.mwp__terms', '[data-mwp-dyn]', '[data-mw-offer-note]'].forEach(function (s) { var el = $(s, root); if (el) el.style.display = ''; });
      update();
      setUrl(0);
    }

    /* option clicks: handled here first (capture), before mwh-pdp.js */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio' || !root.contains(t)) return;
      if (lenFs.contains(t)) {
        if (t === radio) { e.stopImmediatePropagation(); enter(); }
        else if (on) exit(); /* mwh-pdp.js then renders the box/reel as normal */
        return;
      }
      if (on && sizeFs.contains(t)) {
        e.stopImmediatePropagation();
        /* keep the hidden variant select on this size for the quote form */
        var pool = mains.filter(function (v) { return v.options[cfg.size] === t.value; });
        var pick = pool.filter(function (v) { return v.available; })[0] || pool[0];
        if (pick && select) select.value = String(pick.id);
        update();
      }
    }, true);

    /* "Select" in the sizes & pricing table returns to a box/reel */
    document.addEventListener('click', function (e) {
      if (on && e.target.closest && e.target.closest('[data-mwd-pick]')) exit();
    }, true);

    /* the "Better value" switch */
    $('[data-mwc-switch]', tipEl).addEventListener('click', function () {
      var v = this.getAttribute('data-value');
      var r = $$('input[type="radio"]', lenFs).filter(function (i) { return i.value === v; })[0];
      if (r) r.click();
    });

    /* length input */
    ftIn.addEventListener('input', update);
    ftIn.addEventListener('blur', function () {
      var n = feet();
      if (!(n >= 1)) ftIn.value = cfg.min;
      else if (n < cfg.min) ftIn.value = cfg.min;
      else ftIn.value = n;
      update();
    });
    $$('[data-mwc-step]', panel).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = feet();
        if (!isFinite(n)) n = cfg.def;
        n += parseInt(b.getAttribute('data-mwc-step'), 10);
        ftIn.value = Math.min(cfg.max, Math.max(cfg.min, n));
        update();
      });
    });

    /* add to cart: per-foot variant, quantity = feet */
    function busy(onoff, text) {
      [atc, sticky && $('[data-mwp-stickyatc]', sticky)].forEach(function (b) {
        if (!b) return;
        b.classList.toggle('is-busy', onoff);
        if (onoff) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
      });
      if (text) {
        if (atcText) atcText.textContent = text;
        var st = sticky && $('[data-mwp-stickytext]', sticky);
        if (st) st.textContent = text;
      }
    }
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    document.addEventListener('submit', function (e) {
      if (!on || e.target !== form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var size = sizeVal();
      var c = cutFor(size);
      var ft = feet();
      if (!c || !c.available || !(ft >= cfg.min && ft <= cfg.max)) { update(); ftIn.focus(); return; }
      var props = {};
      if (cfg.prop) props[cfg.prop] = String(cfg.propVal || '').replace('[ft]', ft);
      props._cut_ref = Date.now().toString(36); /* keeps each cut on its own line */
      busy(true, 'Adding…');
      if (msg) { msg.textContent = ''; msg.classList.remove('is-err'); }
      fetch(base + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: c.id, quantity: ft, properties: props }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add to cart');
          busy(false, 'Added ✓');
          if (msg) msg.textContent = ft + ' ft of ' + size + ' cable, cut to length, added to your cart.';
          fetch(base + 'cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              $$('[data-mwh-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
              $$('.mwh-cart').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's')); });
            }).catch(function () {});
          if (window.Shopify && typeof Shopify.KT_getCart === 'function') {
            try { Shopify.KT_getCart(); } catch (err) {}
          } else {
            window.location.href = root.getAttribute('data-cart') || '/cart';
          }
          document.dispatchEvent(new CustomEvent('mwp:added', { detail: { variant: c, quantity: ft, cut: true } }));
          setTimeout(update, 2200);
        })
        .catch(function (err) {
          busy(false);
          update();
          if (msg) { msg.textContent = err.message; msg.classList.add('is-err'); }
        });
    }, true);

    update();

    /* deep link: ?cut or ?cut=40 opens Custom Cut (ads, quotes, emails) */
    try {
      var q = new URL(window.location.href).searchParams;
      if (q.has('cut')) {
        var n = parseInt(q.get('cut'), 10);
        if (n > 0) ftIn.value = n;
        enter();
      }
    } catch (e) {}
  }

  function init() { $$('[data-mwc]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
